// extracted by mini-css-extract-plugin
export default {"star":"StarRatings_star__nRbzc","tooltip":"StarRatings_tooltip__B3r8O","defaultRating":"StarRatings_defaultRating__1lUss"};